export default __webpack_public_path__ + "static/media/logoLMS.034b3f64.svg";